export const FULL_WEEK_DAYS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
export const SHORT_WEEK_DAYS = ["D", "L", "M", "M", "J", "V", "S"];
export const ROLES = { admin: 'admin', user: 'user', assistant: 'assistant' }